import chroma from 'chroma-js';

const DEFAULT_COLORS = [
  'rgb(180, 0, 0)',
  'rgb(255, 115, 0)',
  'rgb(255, 200, 0)',
  'rgb(133, 204, 0)',
  'rgb(0, 106, 0)',
];

const DARKER_COLORS = [
  'rgb(155, 0, 0)',
  'rgb(230, 103, 0)',
  'rgb(204, 160, 0)',
  'rgb(99, 153, 0)',
  'rgb(0, 85, 0)',
];

/**
 * Returns a color hex string representing the progress state for a given
 * percentage. The color is interpolated from a scale of colors, with an optional dark mode.
 *
 * @param percentage The progress percentage (0-100).
 * @param dark If `true`, uses a darker color scale for dark mode.
 * @returns The interpolated color as a hex string.
 */
function getProgressColor(percentage: number, dark = false): string {
  const chromaScale = chroma
    .scale(dark ? DARKER_COLORS : DEFAULT_COLORS)
    .domain([0, 25, 50, 75, 100]);

  return chromaScale(percentage).hex();
}

export default getProgressColor;
